import React, { useState } from "react";
import styled from "styled-components";
import { Modal, ModalBody } from "shards-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import FormLogin from "shared/components/FormLogin/FormLogin";
import FormRegister from "shared/components/FormRegister/FormRegister";
import FormConfirmeMail from "shared/components/FormConfirmeMail/FormConfirmeMail";
import FormResetPassword from "shared/components/FormResetPassword/FormResetPassword";
import FormLoginSucceed from "shared/components/FormLoginSucceed/FormLoginSucceed";
import { ToastContainer,toast } from "react-toastify";
import { useTranslation } from "react-i18next";

const ModalHeaderStyled = styled.div`
  background-color: #1968bc !important;
  padding: 5px 10px 10px 20px;
  align-items: center;
  color: #fff;
  display: flex;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
`;
const ModalBodyStyled = styled(ModalBody)`
  padding: 35px 70px;
`;
const HeaderBody = styled.div`
  padding: 4px 0px;
  flex: 1 1;
`;
const TitleHeader = styled.div`
  font-size: 18px;
  font-weight: 700;
`;
const SubHeader = styled.div`
  font-size: 8px;
`;
const CloseButton = styled.div`
  border: 1px solid #fff;
  border-radius: 50%;
  background-color: #fff;
  color: #1968bc;
  align-items: center;
  height: 13px;
  width: 13px;
  display: flex;
  padding: 0px 2px;
  justify-content: center;
  font-size: 10px;
  align-content: center;
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
`;
const ModalLogin = (pops) => {
  const { t, i18n } = useTranslation();
  const { visible, onCancel, statusModal } = pops;
  const [status, setStatus] = useState(statusModal ? statusModal :1);

  const showNotify = (message, type) => {
    switch (type) {
      case "success":
        toast.success(message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
        break;
      case "error":
        toast.error(message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
        break;
      case "warn":
        toast.warn(message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
        break;
      case "info":
        toast.info(message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
        break;
      default:
        toast.success(message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
    }
  };

  const onChangeStatus = (status) => {
    setStatus(status);
  };

  const onCloseModal = () => {
    setStatus(statusModal ? statusModal :1);
    onCancel()
  }
  if (visible) {
    document.body.style.overflowX = "hidden";
    document.body.style.overflowY = "hidden";
  } else {
    document.body.style.overflowX = "hidden";
    document.body.style.overflowY = "auto";
  }
  return (
    <Modal
      size={status === 2 ? "lg" : "md"}
      open={visible}
      toggle={() => {
        onCancel();
        setStatus(1);
      }}
      backdrop={true}
    >
      <ModalHeaderStyled className="modal-header">
        <a href="/">
          <img
            className="mr-2"
            src={require("../../assets/img/logo.png")}
            alt="logo"
          />
        </a>
        <HeaderBody>
        <ToastContainer />
          <TitleHeader>
          {t("common:logIn.Titles")}
          </TitleHeader>
        </HeaderBody>
        <CloseButton onClick={onCloseModal}>
          <FontAwesomeIcon icon={faClose} />
        </CloseButton>
      </ModalHeaderStyled>
      <ModalBodyStyled>
        {status === 1 && <FormLogin onChangeStatus={onChangeStatus} />}
        {status === 2 && <FormRegister onChangeStatus={onChangeStatus} />}
        {status === 3 && <FormConfirmeMail onChangeStatus={onChangeStatus}  onCancel={onCloseModal} statusPass={statusModal ? "changePass" : null}/>}
        {status === 4 && <FormResetPassword onChangeStatus={onChangeStatus} />}
        {status === 5 && <FormLoginSucceed onChangeStatus={onChangeStatus} />}
      </ModalBodyStyled>
    </Modal>
  );
};

export default ModalLogin;
